import { createContext } from "react"
import { User } from "../api/types/user"

interface UserContext {
  user: User | undefined
  setUser: (user: User) => void
  login: (username: string, password: string) => Promise<void>
  logout: () => void
  hasRole: () => boolean
  hasPerm: () => boolean
}

const userContext = createContext<UserContext>({
  user: undefined,
  setUser: (user: User): void => { },
  login: async (username: string, password: string): Promise<void> => { },
  logout: (): void => { },
  hasRole: (): boolean => false,
  hasPerm: (): boolean => false,
})

export default userContext
